var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.809,
    height: 20.799,
    viewBox: "0 0 21.809 20.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M21.808,8.06a.947.947,0,0,1-.341.629l-4.757,4.64,1.127,6.553a1.947,1.947,0,0,1,.013.262.773.773,0,0,1-.138.465.463.463,0,0,1-.4.19,1.058,1.058,0,0,1-.524-.158L10.9,17.548,5.02,20.642A1.112,1.112,0,0,1,4.5,20.8a.476.476,0,0,1-.413-.19.776.776,0,0,1-.138-.465,2.143,2.143,0,0,1,.026-.262L5.1,13.328.328,8.689A1,1,0,0,1,0,8.06q0-.485.734-.6L7.314,6.5,10.262.537Q10.511,0,10.9,0t.642.537L14.5,6.5l6.579.957q.734.118.734.6Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f23581e4841c1b104d3ab7edb070a91d.svg";
export { ForwardRef as ReactComponent };